<app-card [title]="(this.request.isArchived ? 'doctrine.service_subject.solution' : 'admin.service_request.choose_solution')|translate">
  <div class="container" *ngIf="this.request">
    <div class="">
      <div *ngIf="!this.request.reply" class="row mb-2">
        <label class="col-sm-3 col-form-label no-padding-right left-pos">
          <div class="labelWithToolTip no-padding-y">
            {{'doctrine.service_subject.subject'|translate}}<span class="star">*</span>
          </div>
          <div class="tooltip-item ">
            <div class="tooltipBox">
              <i class="fa fa-info-circle fa-2x " aria-hidden="true"></i>
            </div>
            <div class="desc-place">
              <ng-container>
                <div>
                  {{'admin.service_request.select_solution'|translate}}
                </div>
              </ng-container>
            </div>
          </div>
        </label>
        <div class="col-sm-9">
          <ng-select *ngIf="!this.request.reply" name="serviceSubject"
                     [items]="serviceSubjects"
                     [required]="true"
                     [(ngModel)]="serviceSubject"
                     (ngModelChange)="changeServiceSubject($event)"
                     bindLabel="label"
                     bindValue="value"
                     [clearable]="false">
            <ng-template ng-notfound-tmp let-searchTerm="searchTerm">
              <div class="ng-option disabled text-black-50">
                {{'doctrine.order.no_result_found_for'|translate}} {{searchTerm}}
              </div>
            </ng-template>
            <ng-template ng-loadingtext-tmp let-searchTerm="searchTerm">
              <div class="ng-option disabled text-black-50">
                {{'doctrine.order.search_for'|translate}} {{searchTerm}}
              </div>
            </ng-template>
          </ng-select>
        </div>
      </div>
      <div class="row">
        <label class="col-sm-3 col-form-label no-padding-right left-pos">
          <div class="labelWithToolTip no-padding-y">
            {{'doctrine.service_subject.solution'|translate}}<span class="star">*</span>
          </div>
          <div class="tooltip-item ">
            <div class="tooltipBox">
              <i class="fa fa-info-circle fa-2x " aria-hidden="true"></i>
            </div>
            <div class="desc-place">
              <ng-container>
                <div>
                  {{'admin.service_request.select_solution'|translate}}
                </div>
              </ng-container>
            </div>
          </div>
        </label>
        <div class="col-sm-9">
          <ng-select *ngIf="!this.request.reply" name="solution"
                     [items]="solutions"
                     [required]="true"
                     [(ngModel)]="solution"
                     (change)="changeSolution($event)"
                     bindLabel="label"
                     bindValue="value"
                     [clearable]="false"
                     [disabled]="!serviceSubjectIsSelected">
            <ng-template ng-notfound-tmp let-searchTerm="searchTerm">
              <div class="ng-option disabled text-black-50">
                {{'doctrine.order.no_result_found_for'|translate}} {{searchTerm}}
              </div>
            </ng-template>
            <ng-template ng-loadingtext-tmp let-searchTerm="searchTerm">
              <div class="ng-option disabled text-black-50">
                {{'doctrine.order.search_for'|translate}} {{searchTerm}}
              </div>
            </ng-template>
          </ng-select>
          <span *ngIf="this.request.reply">{{this.request.reply.solution.name}}</span>
        </div>
      </div>
      <div class="row mt-2" *ngIf="this.request.canceledReplies?.length">
        <div class="col-sm-3">
          <b>{{'doctrine.service.canceled_solutions' | translate}}</b>
        </div>
        <div class="col-sm-9">
          <p *ngFor="let reply of this.request.canceledReplies">
            <a routerLink="/back-office/service/request/{{this.request.id}}/show/{{reply.id}}/archive">{{reply.solution.name}}</a>
          </p>
        </div>
      </div>
    </div>
    <div class="row mt-2">
      <div class="col-sm-12">
        <button *ngIf="!this.request.isArchived && this.request.reply" type="button" class="btn btn-primary ripple light pull-right"
                (click)="confirmCancelModal.show()">{{'global.cancel'|translate}}</button>
        <button *ngIf="!solutionIsSelected" [disabled]="!solution" class="btn btn-primary ripple light pull-right"
                (click)="confirmModal.show()" type="button">{{'global.select'|translate}}</button>
      </div>
    </div>
  </div>
</app-card>

<app-modal-basic *ngIf="!solutionIsSelected" #confirmModal>
  <div class="app-modal-header">
    <h4 class="modal-title">{{ 'global.confirm' | translate }}</h4>
    <button type="button" class="close basic-close" (click)="confirmModal.hide()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="app-modal-body">
    <p>{{ 'global.soft_select_body' | translate : {item: 'solution'} }}</p>
  </div>
  <div class="app-modal-footer">
    <button type="button" class="btn btn-simple ripple me-4"
            (click)="confirmModal.hide()">{{'global.cancel'|translate}}</button>
    <button type="button" class="btn btn-primary ripple light"
            (click)="selectSolution()">{{'global.confirm'|translate}}</button>
  </div>
</app-modal-basic>

<app-modal-basic #confirmCancelModal>
  <div class="app-modal-header">
    <h4 class="modal-title">{{ 'global.cancel_solution' | translate }}</h4>
    <button type="button" class="close basic-close" (click)="confirmCancelModal.hide()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="app-modal-body">
    <p>{{ 'global.cancel_solution_body' | translate }}</p>
  </div>
  <div class="app-modal-footer">
    <button type="button" class="btn btn-simple ripple me-4"
            (click)="confirmCancelModal.hide()">{{'global.no'|translate}}</button>
    <button type="button" class="btn btn-primary ripple light"
            (click)="cancelSolution()">{{'global.yes'|translate}}</button>
  </div>
</app-modal-basic>
